/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';

import {AngularResourceListManager} from '../common/controller/angular-resource-list-manager';
import {AdnHttpService} from '../../components/util/adn-http.service';
import {ApiErrorHandlerService} from '../common/directives/error/api-error-handler.service';
import {AuthHttpInterceptorService} from '../../components/auth/auth-http-interceptor.service';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {WINDOW} from '../angular-platform-providers';

@Component({
  standalone: false,
  selector: 'adn-political-campaign-route-page',
  template: `
    <adn-political-campaign-list-page
      *ngIf="list"
      [list]="list">
    </adn-political-campaign-list-page>
  `
})
export class PoliticalCampaignRoutePageComponent implements OnInit, OnDestroy {
  list: any;

  private listManager: AngularResourceListManager;

  constructor(
    private readonly AdnHttp: AdnHttpService,
    private readonly authHttpInterceptor: AuthHttpInterceptorService,
    private readonly ApiErrorHandler: ApiErrorHandlerService,
    @Inject(LocalUserProfile) private readonly localUserProfile: LocalUserProfile,
    @Inject(WINDOW) private readonly window: Window,
    @Inject(LocalUserPermissions) private readonly localUserPermissions: LocalUserPermissions,
    private readonly ngZone: NgZone
  ) {}

  ngOnInit(): void {
    const readOnly = !this.localUserPermissions.canEditPoliticalResources();
    this.listManager = new AngularResourceListManager({
      AdnHttp: this.AdnHttp,
      authHttpInterceptor: this.authHttpInterceptor,
      ApiErrorHandler: this.ApiErrorHandler,
      window: this.window,
      localUserProfile: this.localUserProfile,
      ngZone: this.ngZone
    }, {
      resourcePath: 'politicalcampaigns',
      listId: 'fullPoliticalCampaignList',
      defaultOrderByParam: 'name'
    });
    this.list = this.listManager.list;
    this.list.readOnly = readOnly;
    this.listManager.load();
  }

  ngOnDestroy(): void {
    this.listManager?.destroy();
  }
}
